export const SET_ACTIVE_SPECIALTY = 'SET_ACTIVE_SPECIALTY';
